module.exports = __webpack_public_path__ + "static/overview-e0820959012b974027887b8b0e27ae7c.png";